document.addEventListener('DOMContentLoaded', function () {
    var checkoutForm = document.getElementById('CartDrawer-Form');

    if (checkoutForm) {
        checkoutForm.addEventListener('submit', function (event) {
            // Fire the begin_checkout event
            console.log("Firing begin_checkout event.");
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'begin_checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': { 'step': 1 },
                        'products': [] // You can dynamically add product details here
                    }
                }
            });

            // Allow the form to continue submission
        });
    }
});
